<template>
  <component :is="tagName">
    <transition :name="transition">
      <span class="legenda"
        ref="legenda"
        v-show="!disabled && showLegenda">
        <slot>{{ content }}</slot>
      </span>
    </transition>
    <slot name="referencia"></slot>
  </component>
</template>

<script>
  function on(element, event, handler) {
    if (element && event && handler) {
      document.addEventListener ? element.addEventListener(event, handler, false) : element.attachEvent('on' + event, handler);
    }
  }

  function off(element, event, handler) {
    if (element && event) {
      document.removeEventListener ? element.removeEventListener(event, handler, false) : element.detachEvent('on' + event, handler)
    }
  }

  export default {
    name: 'Legenda',
    props: {
      tagName: {
        type: String,
        default: 'span',
      },

      delayOnMouseOver: {
        type: Number,
        default: 1700,
      },

      delayOnMouseOut: {
        type: Number,
        default: 1700,
      },
    
      disabled: {
        type: Boolean,
        default: false
      },

      content: String,
      referencia: {},
      forceShow: {
        type: Boolean,
        default: false
      },
    
      transition: {
        type: String,
        default: ''
      },

      preventDefault: {
        type: Boolean,
        default: false
      },
    
    },

    data() {
      return {
        referenceElm: null,
        showLegenda: false,
      };
    },
    created() {
      this.appendedArrow = false;
      this.appendedToBody = false;
    },

    mounted() {
      this.referenceElm = this.referencia || this.$slots.referencia[0].elm;
      on(this.referenceElm, 'click', this.doToggle);
      on(document, 'click', this.handleDocumentClick);
      on(this.referenceElm, 'mouseover', this.onMouseOver);
      on(this.referenceElm, 'mouseout', this.onMouseOut);
    },

    methods: {
      doToggle(event) {
        if(this.stopPropagation) {
          event.stopPropagation();
        }

        if(this.preventDefault) {
          event.preventDefault();
        }

        if (!this.forceShow) {
          this.showLegenda = !this.showLegenda;
        }
      },

      doShow() {
        this.showLegenda = true;
      },

      doClose() {
        this.showLegenda = false;
      },
    
      onMouseOver() {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => {
          this.showLegenda = false;
        }, this.delayOnMouseOver);
      },
      onMouseOut() {
        var _this3 = this;
        clearTimeout(this._timer);
        this._timer = setTimeout(function() {
          _this3.showLegenda = false;
        }, this.delayOnMouseOut);
      },

    },

  }
</script>
<style>
  .legenda {
    width: auto;
    background-color: #0077b5!important;
    color: #fff;
    text-align: center;
    padding: 2px;
    display: inline-block;
    border-radius: 3px;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    z-index: 200000;
    -moz-box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    -webkit-box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    margin-top: -25px;
  
  }

  .legenda::before{
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #0077b5 transparent transparent transparent;
  }

  .legenda {
    margin-bottom: 5px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Legendas.vue